import {Button, Chip, Typography} from "@material-tailwind/react";
import {ChevronUpDownIcon} from "@heroicons/react/24/outline";
import React, {useEffect, useState} from "react";
import {getAgentAgentBranchs, submitAgentBranch, updateAgentBranch} from "../../../services/agent/agent_branch";
import {getAgentRequestBranchs} from "../../../services/agent/request_branch";
import Dict from "../../../helper/dict";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
// import FileCell from "../system/fileViewer";


const TABLE_HEAD = ["#", "کدمشاور", "رشته", "گرایش", "وضعیت", "عملیات"];

export function BranchGrid({agentId, lastDataRefresh, setLastDataRefresh}) {

  const [agentBranchList, setAgentBranchList] = useState([])
  const [requestBranchList, setRequestBranchList] = useState([])
  const [requestBranchListNew, setRequestBranchListNew] = useState([])

  // useEffect(() => {
  //   setAgentBranchList(agentBranchList)
  //   setRequestBranchList(requestBranchList)
  //   setRequestBranchListNew(requestBranchListNew)
  // }, []);

  // TODO: edit query to get field and branch title
  useEffect(() => {
    const id = agentId

    async function getData(id) {
      const result = await getAgentRequestBranchs(id)
      if (result.status === 200) {
        const {request_branch_list} = result.data;
        setRequestBranchList(request_branch_list);
        setRequestBranchListNew((request_branch_list) || [])
      }
      const result_agent = await getAgentAgentBranchs(id)
      if (result_agent.status === 200) {
        const {agent_branch_list} = result_agent.data;
        setAgentBranchList("agent_branch_list");
        setAgentBranchList(agent_branch_list || []);
      }
    }

    getData(id)
  }, [lastDataRefresh])

  const submit_branch = async (branch, state, action) => {
    const data = {
      id: branch.id,
      agent_id: branch.agent_id,
      field_id: branch.field_id,
      branch_id: branch.branch_id,
      status: state === 'accepted' ? 'accepted' : 'rejected',
    }
    let result;

    if (action === 'new') {
      result = await submitAgentBranch(data)
    } else if (action === 'old') {
      result = await updateAgentBranch(data)
    }

    if (result.status === 200) {
      const {agent_branch} = result.data;
    }
    setLastDataRefresh(Date.now())
  }

  return (
    <div className="w-full overflow-x-scroll">

      <Typography>
        گرایشات‌بررسی‌نشده
      </Typography>
      <table className="mt-4 w-full">
        <thead>
        <tr>
          {TABLE_HEAD.map((head, index) => (
            <th key={head}
                className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
              <Typography variant="small" color="blue-gray"
                          className="flex items-center justify-between gap-2 font-normal leading-none opacity-70 flex justify-center">
                {head}{" "}
                {index !== TABLE_HEAD.length - 1 && (
                  <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4 sticky "/>
                )}
              </Typography>
            </th>
          ))}
        </tr>
        </thead>
        <tbody className="textCenter">
        {requestBranchListNew.map(
          ({agent_id, field_title, branch_title, status}, index) => {
            const isLast = index === requestBranchListNew.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={index}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(agent_id)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {field_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip className="textRight" variant="ghost"
                          value={status === "accepted" ? "قبول" : status === "rejected" ? "رد" : status === "new" ? "جدید" : "cyan"}
                          color={status === "accepted" ? "teal" : status === "rejected" ? "red" : status === "new" ? "amber" : "cyan"}/>
                  </div>
                </td>

                <td className={classes}>
                  {status && status !== "accepted" &&
                    <Button className="mx-2" variant="outlined" color="green"
                            onClick={() => {
                              submit_branch(requestBranchListNew[index], 'accepted', 'new')
                            }}
                    >
                      تایید
                    </Button>
                  }
                  {status && status !== "rejected" &&
                    <Button className="mx-2" variant="outlined" color="red"
                            onClick={() => {
                              submit_branch(requestBranchListNew[index], 'rejected', 'new')
                            }}
                    >
                      عدم‌تایید
                    </Button>
                  }
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>

      <Typography>
        گرایشات‌بررسی‌شده
      </Typography>
      <table className="mt-4 w-full">
        <thead>
        <tr>
          {TABLE_HEAD.map((head, index) => (
            <th key={head}
                className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
              <Typography variant="small" color="blue-gray"
                          className="flex items-center justify-between gap-2 font-normal leading-none opacity-70 flex justify-center">
                {head}{" "}
                {index !== TABLE_HEAD.length - 1 && (
                  <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4 sticky "/>
                )}
              </Typography>
            </th>
          ))}
        </tr>
        </thead>
        <tbody className="textCenter">
        {agentBranchList.map(
          ({agent_id, field_title, branch_title, status}, index) => {
            const isLast = index === agentBranchList.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={index}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(agent_id, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {field_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip className="textRight" variant="ghost"
                          value={Dict(status)}
                          color={status === "accepted" ? "teal" : status === "rejected" ? "red" : status === "new" ? "cyan" : "red"}/>
                  </div>
                </td>

                <td className={classes}>
                  {status && status !== "accepted" &&
                    <Button className="mx-2" color="green" variant="outlined"
                            onClick={() => {
                              submit_branch(agentBranchList[index], 'accepted', 'old')
                            }}
                    >
                      تایید
                    </Button>
                  }
                  {status && status !== "rejected" &&
                    <Button className="mx-2" color="red" variant="outlined"
                            onClick={() => {
                              submit_branch(agentBranchList[index], 'rejected', 'old')
                            }}
                    >
                      عدم‌تایید
                    </Button>
                  }
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}